import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "5.862"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.001 5.862a.69.69 0 0 1-.5-.212L.192 1.168a.689.689 0 1 1 .992-.956l3.814 3.966L8.811.212a.69.69 0 1 1 .994.956L5.493 5.65a.68.68 0 0 1-.492.212",
      "data-name": "Path 874"
    }, null, -1)
  ])))
}
export default { render: render }